import * as React from 'react';
import { safe, isNullOrUndefined, getViewFundList } from "../../utils";
import { IPageProperties, IExplorerProperties, IWatchlist } from "../../models";

const FaClose = require('react-icons/lib/fa/times-circle');
const styles = require('./WatchlistButton.pcss');

interface IProps {
	isin?: string;
	isMobile?: boolean;
	buttonStyle?: any;
	fundName?: string;
	fundIdentifier?: string;
}

export class WatchlistButton extends React.Component<IExplorerProperties & IProps, {}>{
	constructor(props) {
		super(props);
		this.handleWatchlist = this.handleWatchlist.bind(this);
	}

	handleWatchlist(watchlistItems: IWatchlist, isRemove, event) {
		event.stopPropagation();
		event.preventDefault();
		let { appParams, isin, fundIdentifier, fundName } = this.props;
		this.props.editWatchlist({ isin, fundIdentifier, fundName }, appParams, isRemove);
	}

	getButtonType(watchlist: IWatchlist[]) {
		let { isMobile, buttonStyle, appParams } = this.props;
		let watchlistItem = watchlist.filter((item) => this.props.isin === item.isin && item.fundList === getViewFundList(appParams));
		if (watchlistItem.length === 0) {
			return (
				<button
					type="button"
					onClick={e => this.handleWatchlist(this.props as IWatchlist, false, e)}
					className={isMobile ? buttonStyle : styles.addToWishList}>
					{(() => {
						if (isMobile) {
							return `Add to Watchlist`;
						} else {
							return <em><span>+</span></em>;
						}
					})()}
				</button>);
		} else {
			return (
				<button
					type="button"
					onClick={e => this.handleWatchlist(this.props as IWatchlist, true, e)}
					className={isMobile ? buttonStyle : styles.addToWishList}>
					{(() => {
						if (isMobile) {
							return `Remove from Watchlist`;
						} else {
							return <em><span>-</span></em>;
						}
					})()}
				</button>);
		}
	}

	render() {
		if (isNullOrUndefined(this.props.watchlist)) {
			return <div></div>;
		}

		let { watchlist } = this.props;
		return this.getButtonType(watchlist);
	}
}


// WEBPACK FOOTER //
// ./src/client/components/WatchlistButton/index.tsx